export interface ThemeColors {
  primary: string;
  secondary: string;
  background: string;
  text: string;
  border: string;
  accent: string;
}

export const THEMES: { [key: string]: ThemeColors } = {
  'dark-fantasy': {
    primary: '#8B4513',
    secondary: '#4A2511',
    background: '#1a0f0a',
    text: '#e0d5c7',
    border: '#5a3825',
    accent: '#d4a574'
  },
  'horror': {
    primary: '#8B0000',
    secondary: '#3a0000',
    background: '#0a0000',
    text: '#e0c0c0',
    border: '#5a0000',
    accent: '#ff4444'
  },
  'isekai': {
    primary: '#4169E1',
    secondary: '#1e3a8a',
    background: '#0a0f1e',
    text: '#e0e8f0',
    border: '#2a4a8a',
    accent: '#60a5fa'
  },
  'steampunk': {
    primary: '#8B7355',
    secondary: '#5a4a3a',
    background: '#1a1510',
    text: '#e0d5c0',
    border: '#6a5a4a',
    accent: '#c9a871'
  },
  'cyberpunk': {
    primary: '#00ffff',
    secondary: '#0080a0',
    background: '#0a0a1a',
    text: '#e0f0ff',
    border: '#00a0c0',
    accent: '#ff00ff'
  },
  'post-apocalypse': {
    primary: '#808000',
    secondary: '#4a4a00',
    background: '#1a1a0a',
    text: '#d0d0c0',
    border: '#6a6a2a',
    accent: '#b8b860'
  },
  'lovecraftian': {
    primary: '#2F4F4F',
    secondary: '#1a2f2f',
    background: '#050a0a',
    text: '#c0d0d0',
    border: '#3a5a5a',
    accent: '#5a8a8a'
  },
  'cultivation': {
    primary: '#DAA520',
    secondary: '#8B6914',
    background: '#0f0a05',
    text: '#f0e5d0',
    border: '#9a7a2a',
    accent: '#ffd700'
  },
  'space-opera': {
    primary: '#4B0082',
    secondary: '#2a0050',
    background: '#0a0010',
    text: '#e0d0f0',
    border: '#5a3070',
    accent: '#9370db'
  },
  'sword-and-sorcery': {
    primary: '#CD853F',
    secondary: '#8B5A2B',
    background: '#150f0a',
    text: '#e8d8c8',
    border: '#7a5a3a',
    accent: '#daa520'
  },
  'default': {
    primary: '#ffffff',
    secondary: '#888888',
    background: '#000000',
    text: '#e0e0e0',
    border: '#555555',
    accent: '#ffffff'
  }
};

export function applyTheme(themeName: string) {
  const theme = THEMES[themeName] || THEMES['default'];
  const root = document.documentElement;

  root.style.setProperty('--theme-primary', theme.primary);
  root.style.setProperty('--theme-secondary', theme.secondary);
  root.style.setProperty('--theme-background', theme.background);
  root.style.setProperty('--theme-text', theme.text);
  root.style.setProperty('--theme-border', theme.border);
  root.style.setProperty('--theme-accent', theme.accent);
}
